import { render } from "./LeftDrawer.vue?vue&type=template&id=15bb01f3&scoped=true"
import script from "./LeftDrawer.vue?vue&type=script&lang=js"
export * from "./LeftDrawer.vue?vue&type=script&lang=js"

import "./LeftDrawer.vue?vue&type=style&index=0&id=15bb01f3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bb01f3"]])

export default __exports__